import { fmtPrice } from '@upstart/harmony/lib/formatter';
import React from 'react';
import {
  FinanceResponse,
  Rate,
} from '@upstart/harmony/lib/legos/financingTypes';

const CounterOfferSummaryTable: React.FC<{
  originalResponse: FinanceResponse;
  maxAllowableRate?: Rate;
  maxAllowableFinanceAmount: number;
  financeAmount: number;
}> = ({
  originalResponse,
  maxAllowableRate,
  financeAmount,
  maxAllowableFinanceAmount,
}) => (
  <table data-testid="CounterSummaryTable" className="offer-counter-table">
    <tbody>
      <tr>
        <td>Requested</td>
        <td data-testid="CounterSummaryTable-requestedAmount">
          {fmtPrice(originalResponse?.data?.financeAmount ?? 0)}
        </td>
      </tr>
      <tr>
        <td>Approved</td>
        <td data-testid="CounterSummaryTable-maxApproved">
          {fmtPrice(maxAllowableRate?.maxFinanceAmount ?? 0)}
        </td>
      </tr>
      <tr>
        <td>Current</td>
        <td
          data-testid="CounterSummaryTable-currentFinanceAmount"
          className={`UpstartFinanceDetails-${
            financeAmount > maxAllowableFinanceAmount ? 'error' : 'valid'
          }`}
        >
          {fmtPrice(financeAmount)}
        </td>
      </tr>
    </tbody>
  </table>
);

export default CounterOfferSummaryTable;
